import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { jt, t } from 'ttag'
import { Modal } from 'react-bootstrap'
import { actions as formActions } from 'react-redux-form'
import { CSSTransitionGroup } from 'react-transition-group'
import { useParams } from 'react-router-dom'

import {
  addCustomOption,
  loadBudget,
  setActiveRound,
  updateBudgetResponse
} from '../../actions/assessments/budget'
import BudgetFooterBar from '../../components/assessment/budget/BudgetFooterBar'
import BudgetRoundCost from '../../components/assessment/budget/BudgetRoundCost'
import Field from '../../components/form/Field'
import Form from '../../components/form/Form'
import { browserHistory } from '../../Routes'
import { updatePageTitle } from '../../actions/pageInfo'
import LoadingIndicator from '../../components/LoadingIndicator'

const BudgetQuestion = props => {
  const params = useParams()
  const [selectedQuestion, setSelectedQuestion] = useState({})
  const [isForwardMove, setForwardMove] = useState(true)
  const [roundResponse, setRoundResponse] = useState({})
  const [showAddCustomModal, setShowAddCustomModal] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const roundId = params.roundId ? parseInt(params.roundId) : 0
  const {
    questions,
    currentRound,
    occupation,
    responses,
    county,
    rounds,
    startingSalary,
    monthlyTotal,
    dispatch,
    onAddCustomOption
  } = props

  useEffect(() => {
    console.log('LOADING BUDGET')
    dispatch(loadBudget()).then(b => {
      console.log('SETTING ROUND')
      setForwardMove(currentRound > roundId)
      dispatch(setActiveRound(roundId))
      dispatch(
        updatePageTitle(
          `${dynamicValues.budgetTitle} :: ${
            b.questions.find(q => q.round === roundId).name
          }`
        )
      )
      setSelectedQuestion(b.questions.find(q => q.round === roundId))
      setRoundResponse(
        b.responses.find(r => r.round === roundId) || {
          total: 0,
          choices: [],
          round: roundId
        }
      )
    })
    console.log('DONE')

    return () => dispatch(updatePageTitle(null))
  }, [roundId])

  const toggle = (optionId, cost, hasOption, multiplier, multipleResponses) => {
    if (multipleResponses) {
      setRoundResponse({
        ...roundResponse,
        choices: hasOption
          ? roundResponse.choices.filter(c => c !== optionId)
          : [...roundResponse.choices, optionId],
        total: hasOption
          ? Math.max(0, roundResponse.total - cost)
          : roundResponse.total + cost
      })
    } else {
      setRoundResponse({
        ...roundResponse,
        choices: [optionId],
        total: multiplier
          ? Math.max(0, Math.round(props.monthlyTotal * (cost / 100)))
          : cost
      })
    }
  }
  const closeModal = () => {
    setShowAddCustomModal(false)
  }

  console.log('BD', selectedQuestion, roundResponse, props)

  if (!selectedQuestion || Object.keys(selectedQuestion).length == 0) {
    return <LoadingIndicator newSiteLook={true} />
  }

  console.log('FOUND SQ', selectedQuestion)

  if (!questions) {
    // console.log(props)
    return <div>Error</div>
  }
  // console.log(this.state.quest)

  const boldedSave = <b>{t`Save`}</b>
  const nextRnd = rounds
    .filter(r => r.visibleMenu)
    .find(r => r.roundId === currentRound + 1) || {
    id: 'total',
    name: t`Total`
  }
  const roundDetails = () => {
    return (
      <div style={{ clear: 'both' }} className="clearfix">
        <p className="question">{selectedQuestion.question}</p>
        <div className="round">
          <ul id="options" style={{ opacity: isSubmitting ? '.4' : '1' }}>
            {selectedQuestion.options.map((o, idx) => (
              <li
                key={idx}
                className={`option option-resp-${o.id} round-${currentRound}-pos-${o.position}`}>
                <a
                  onClick={() => {
                    toggle(
                      o.id,
                      o.cost,
                      !!roundResponse.choices.find(v => v === o.id),
                      selectedQuestion.multiplier,
                      selectedQuestion.multipleResponses
                    )
                    // console.log(o)
                  }}
                  id={`resp-${o.id}`}
                  className={`budget-option text ${
                    roundResponse.choices?.find(v => v === o.id) ? 'selected' : ''
                  }`}>
                  <div>
                    <div className="image"></div>
                    <div className="optn">
                      <span>{o.title}</span>
                      <span className="desc">{o.description}</span>
                    </div>
                    <br className="clear" />
                  </div>
                </a>
              </li>
            ))}
            {selectedQuestion.customResponses && (
              <button
                className="btn btn-gray"
                onClick={() => {
                  props.dispatch(formActions.reset('assessments.budget.customOptionForm'))
                  setShowAddCustomModal(true)
                }}>
                <div className="add pull-left"></div>
                <span>{t`Add a new expense`}</span>
              </button>
            )}
          </ul>
        </div>

        <BudgetRoundCost
          rounds={rounds}
          onUpdateValue={v => {
            if (!isNaN(v)) {
              setRoundResponse({
                ...roundResponse,
                total: !v ? '' : Math.max(parseInt(v), 0)
              })
            }
          }}
          currentRound={currentRound}
          isSubmitting={isSubmitting}
          onMoveNext={() => {
            setIsSubmitting(true)
            props
              .onMoveNext(roundResponse, nextRnd)
              .then(() => setIsSubmitting(false))
              .catch(() => setIsSubmitting(false))
          }}
          value={roundResponse.total}
        />
      </div>
    )
  }

  return (
    <div
      className="container budget"
      id="budget-round"
      style={{ position: 'relative', overflow: 'hidden' }}>
      <CSSTransitionGroup
        component="div"
        transitionName={isForwardMove ? 'h2animate-home' : 'h2animate'}
        transitionEnterTimeout={400}
        transitionLeaveTimeout={400}>
        {React.cloneElement(roundDetails(), { key: currentRound })}
      </CSSTransitionGroup>

      <br className="clear" />
      <BudgetFooterBar
        currentRound={currentRound}
        responses={responses}
        rounds={rounds}
        occupation={occupation}
        forwardBudget={!props.reverse}
        county={county}
        startingSalary={startingSalary}
        monthlyTotal={monthlyTotal}
      />
      <br className="clear" />
      <Modal show={showAddCustomModal} bsSize="lg" onHide={closeModal}>
        <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
          <button type="button" className="close" aria-label="Close" onClick={closeModal}>
            <span aria-hidden="true">×</span>
          </button>
          <h2>{t`Add a New Option`}</h2>
        </Modal.Header>
        <Modal.Body>
          <p className="instructions">
            {jt`Using the boxes below, please describe the expense that you are
                            budgeting for. When you are finished, you can click the ${boldedSave} button.`}
          </p>
          <div id="addoption">
            <Form
              model="assessments.budget.customOptionForm"
              onSubmit={f =>
                props
                  .onAddCustomOption(currentRound, f)
                  .then(o => {
                    const q = o?.questions.find(q => q.id === o.currentRound)
                    const opt = q?.options?.find(
                      opt =>
                        opt.title === f.expenseName &&
                        opt.description === f.description &&
                        opt.cost == parseInt(f.monthlyCost)
                    )

                    console.log(opt, q, f)

                    if (opt) {
                      toggle(
                        opt.id,
                        opt.cost,
                        !!roundResponse.choices.find(v => v === q.id),
                        selectedQuestion.multiplier,
                        selectedQuestion.multipleResponses
                      )
                    }

                    return o
                  })
                  .then(closeModal)}>
              {form => (
                <div>
                  <Field
                    model="assessments.budget.customOptionForm.expenseName"
                    form={form}
                    required={true}
                    placeholder={t`Enter the name of the payee or a short title describing the expense.`}
                    label={t`What is the expense?`}
                    type="text"
                  />
                  <Field
                    model="assessments.budget.customOptionForm.monthlyCost"
                    form={form}
                    required={true}
                    label={t`What is the monthly cost? If you pay annually, divide the cost by 12`}
                    type="number"
                  />
                  <Field
                    model="assessments.budget.customOptionForm.description"
                    form={form}
                    required={false}
                    placeholder={t`In a few sentences, you can describe what the expense is. This is optional, but may help you later identify what the expense was for.`}
                    label={t`Description`}
                    type="textarea"
                  />
                  <div className="nav" style={{ marginTop: '1em' }}>
                    <input type="submit" className="submit" value={t`Save`} />
                    &nbsp;
                    <input
                      type="button"
                      value={t`Cancel`}
                      onClick={closeModal}
                      className="btn btn-danger"
                    />
                  </div>
                </div>
              )}
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    //console.log(state)
    return {
      ...state.assessments.budget.main.result,
      rounds: state.assessments.budget.main.rounds
    }
  },
  dispatch => ({
    onMoveNext: (rnd, nextRnd) => {
      return dispatch(updateBudgetResponse(rnd)).then(v => {
        browserHistory.push(
          nextRnd && nextRnd.id !== 'total'
            ? `/budget/round/${nextRnd.roundId}`
            : `/budget/summary`
        )

        return Promise.resolve(v)
      })
    },
    onAddCustomOption: (roundId, option) => {
      return dispatch(addCustomOption(roundId, option))
    },
    dispatch
  })
)(BudgetQuestion)
